/** Checkout source allowlist — must match functions/subscription_attribution.py */

export const CHECKOUT_SOURCES = {
  WALLET_PLANS: 'wallet_plans',
  MEMBERSHIP_CARD: 'membership_card',
  CREATE_GROUP_MODAL: 'create_group_modal',
  GROUP_JOIN_CAP: 'group_join_cap',
  GROUP_LOCK_POST: 'group_lock_post',
  GROUP_LOCK_ACCEPT: 'group_lock_accept',
  CREATE_LEAGUE_CARD: 'create_league_card',
  LOCKBOX_LEAGUE_HERO: 'lockbox_league_hero',
  GROUPS_PAGE: 'groups_page',
  PROFILE: 'profile',
};

/** Post-checkout session intent — client-only routing, not sent to Stripe */
export const CHECKOUT_INTENTS = {
  CREATE_LEAGUE: 'create_league',
  RETURN_GROUPS: 'return_groups',
};
